import { render } from "./SystemAdmin10.vue?vue&type=template&id=e9445684"
import script from "./SystemAdmin10.vue?vue&type=script&lang=js"
export * from "./SystemAdmin10.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__